import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { ILightWeightObject } from '@fi-shared/models';

@Component({
    selector: 'fi-brand-editor-business-areas-card',
    templateUrl: './fi-brand-editor-business-areas-card.component.html',
    styleUrls: ['./fi-brand-editor-business-areas-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-brand-editor-business-areas-card' },
    standalone: false,
})
export class FiBrandEditorBusinessAreasCardComponent implements OnInit {
    @Input() businessAreaIds: number[];
    @Output() businessAreaIdsChange = new EventEmitter<number[]>();
    @Input() availableBusinessAreas: ILightWeightObject[];

    constructor() {}

    ngOnInit() {}

    onBusinessAreaIdsChanged($event: number[]) {
        this.businessAreaIdsChange.emit($event);
    }
}
